import { render, staticRenderFns } from "./TipoDiagnosticoField.vue?vue&type=template&id=e85c7aa6&scoped=true"
import script from "./TipoDiagnosticoField.vue?vue&type=script&lang=js"
export * from "./TipoDiagnosticoField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85c7aa6",
  null
  
)

export default component.exports